import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router';
import { useGoBack } from '../../lib/navigation.ts';

/**
 * "← Back" at the top of a page. It's a real link to `to`, so it works
 * as a link (new tab, no JavaScript), but a normal tap goes back through
 * the app's history when there is some. `confirmLeave` can stop it, e.g.
 * to keep a half-filled form.
 */
export function BackButton({ to, confirmLeave }: { to: string; confirmLeave?: () => boolean }) {
  const goBack = useGoBack(to);
  return (
    <Link
      to={to}
      onClick={(e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        if (confirmLeave && !confirmLeave()) return;
        goBack();
      }}
      className="-ml-2 inline-flex h-10 items-center gap-1.5 rounded-lg px-2 text-sm font-medium text-muted hover:bg-surface-2 hover:text-text"
    >
      <ArrowLeft className="size-4" aria-hidden />
      Back
    </Link>
  );
}
